module.exports = __webpack_public_path__ + "static/media/option-2.9e53b5eb.ogg";